import { StateCreator } from 'zustand';

export type TabState = {
	activeTabs: Record<string, { tab: string; sub?: string }>;
	setActiveTab: (page: string, tab: string, sub?: string) => void;
	resetTabSlice: () => void;
};

export const createTabSlice: StateCreator<TabState, [], [], TabState> = (set, get) => ({
	activeTabs: {},
	setActiveTab: (page, tab, sub) => {
		const next = { tab, sub: sub ?? undefined };
		const current = get().activeTabs[page];
		if (current && current.tab === next.tab && current.sub === next.sub) return; // ← guard

		set((state) => ({
			activeTabs: { ...state.activeTabs, [page]: next },
		}));
	},
	resetTabSlice: () => set(() => ({ activeTabs: {} })),
});
